import React, { useContext, useEffect, useState } from "react";
import { Button, Space } from "antd";
import { AppContext } from "src/context";
import { AppstoreOutlined } from "@ant-design/icons";
import ThemeToggler from "../common/base/ThemeToggleButton";
import ProfileDropdownMenu from "./ProfileDropdownMenu";
import StartTimerComponent from "../modules/project/project-list/components/tabs/timesheet/Timer";
import BackgroundNotification from "src/common/utils/notification";
import { Notification } from "src/common/types";
import NotificationDropdown from "./notification/NotificationDropdown";

interface NavbarActionsProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

const NavbarActions: React.FC<NavbarActionsProps> = ({
  theme,
  toggleTheme,
}) => {
  const [checking, setChecking] = useState(false);
  const { state } = useContext(AppContext);
  const [items, setItems] = useState<Notification[]>([]);

  const getNotifications = async () => {
    if (localStorage.getItem("token")) {
      setChecking(true);

      const NOTIFICATION = new BackgroundNotification();

      setTimeout(async () => {
        const data = await NOTIFICATION.getNotifications();
        setItems(data as Notification[]);
      }, 1000);

      setTimeout(() => {
        setChecking(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [state.check_notification]);

  return (
    <Space size="middle">
      <StartTimerComponent />
      {/* Theme Toggle Button */}
      <ThemeToggler disabled={true} />

      <NotificationDropdown />

      {/* Nine Dot Menu */}
      {/* <Button shape="circle" icon={<AppstoreOutlined />} /> */}

      {/* User Avatar */}
      {<ProfileDropdownMenu />}
    </Space>
  );
};

export default NavbarActions;
